module.exports = __webpack_public_path__ + "media/images/products/ht1/ht1-1-200x200-a2b600e3df73d8d7780358dd748c9d4b.png";